import React from 'react';
import { useTranslation } from 'react-i18next';

export const SelfRegisterClosed: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="self-register-closed">
      <h2>{t('selfRegisterClosedTitle', 'Registration Closed')}</h2>
      <p>{t('selfRegisterClosedMessage', 'Self-registration is currently closed.')}</p>
    </div>
  );
};
